import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { CONTACT } from "@/data/site";

export const openLegal = (type) =>
  window.dispatchEvent(new CustomEvent("open-legal", { detail: type }));

const Impressum = () => (
  <div className="space-y-6 text-charcoal-soft leading-relaxed text-sm">
    <p className="text-charcoal">Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz)</p>
    <div>
      <p className="text-charcoal font-medium">{CONTACT.legalName}</p>
      <p>Praxis für Ästhetik &amp; Heilpraktik</p>
      <p>{CONTACT.addressLine1}</p>
      <p>{CONTACT.addressLine2}, Deutschland</p>
    </div>
    <div>
      <p className="text-charcoal font-medium">Kontakt</p>
      <p>Telefon: {CONTACT.phone}</p>
      <p>E-Mail: {CONTACT.email}</p>
    </div>
    <div>
      <p className="text-charcoal font-medium">Berufsbezeichnung &amp; berufsrechtliche Regelungen</p>
      <p>Berufsbezeichnung: Heilpraktikerin (verliehen in der Bundesrepublik Deutschland)</p>
      <p>Zuständige Aufsichtsbehörde: Gesundheitsamt der Stadt Fürth</p>
      <p>
        Es gelten das Heilpraktikergesetz (HeilprG) und die Durchführungsverordnung (DVO), einsehbar unter
        www.gesetze-im-internet.de
      </p>
      <p>Mitglied im Fachverband Deutscher Heilpraktiker e.V. (Mitgl.-Nr. 19597)</p>
    </div>
    <div>
      <p className="text-charcoal font-medium">Umsatzsteuer</p>
      <p>
        Heilbehandlungen im Bereich der Humanmedizin sind gemäß § 4 Nr. 14 UStG von der Umsatzsteuer befreit,
        soweit die gesetzlichen Voraussetzungen erfüllt sind.
      </p>
    </div>
    <div>
      <p className="text-charcoal font-medium">Verbraucherstreitbeilegung</p>
      <p>
        Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    </div>
    <div>
      <p className="text-charcoal font-medium">Haftung für Inhalte &amp; Bilder</p>
      <p>
        Alle Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und
        Aktualität der Inhalte kann jedoch keine Gewähr übernommen werden. Alle Bildrechte liegen bei der
        Praxisinhaberin bzw. den jeweiligen Rechteinhabern.
      </p>
    </div>
  </div>
);

const Datenschutz = () => (
  <div className="space-y-6 text-charcoal-soft leading-relaxed text-sm">
    <div>
      <p className="text-charcoal font-medium">1. Verantwortlicher</p>
      <p>{CONTACT.legalName} · Praxis für Ästhetik &amp; Heilpraktik</p>
      <p>{CONTACT.addressLine1}, {CONTACT.addressLine2}</p>
      <p>E-Mail: {CONTACT.email} · Telefon: {CONTACT.phone}</p>
    </div>
    <div>
      <p className="text-charcoal font-medium">2. Allgemeines</p>
      <p>
        Der Schutz Ihrer personenbezogenen Daten ist mir ein wichtiges Anliegen. Die Verarbeitung erfolgt
        ausschließlich auf Grundlage der Datenschutz-Grundverordnung (DSGVO) und des Bundesdatenschutzgesetzes (BDSG).
      </p>
    </div>
    <div>
      <p className="text-charcoal font-medium">3. Kontakt- &amp; Terminanfrageformular</p>
      <p>
        Wenn Sie mir über das Formular eine Anfrage senden, verarbeite ich die von Ihnen angegebenen Daten (Name,
        E-Mail, Telefon, gewünschte Leistung, Nachricht) ausschließlich zur Bearbeitung Ihrer Anfrage und für
        Rückfragen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b und f DSGVO. Die Daten werden gelöscht, sobald sie für
        den Zweck nicht mehr erforderlich sind und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
      </p>
    </div>
    <div>
      <p className="text-charcoal font-medium">4. Gesundheitsdaten</p>
      <p>
        Im Rahmen einer Behandlung können besondere Kategorien personenbezogener Daten (Gesundheitsdaten, Art. 9
        DSGVO) verarbeitet werden. Dies erfolgt ausschließlich auf Grundlage Ihrer ausdrücklichen Einwilligung bzw.
        zum Zweck der Behandlung (Art. 9 Abs. 2 lit. a und h DSGVO) und wird streng vertraulich behandelt.
      </p>
    </div>
    <div>
      <p className="text-charcoal font-medium">5. Google Maps</p>
      <p>
        Diese Website bindet Kartenmaterial des Dienstes Google Maps (Google Ireland Ltd.) ein. Beim Aufruf können
        Daten (u. a. Ihre IP-Adresse) an Google übertragen werden. Weitere Informationen finden Sie in der
        Datenschutzerklärung von Google.
      </p>
    </div>
    <div>
      <p className="text-charcoal font-medium">6. Hosting</p>
      <p>
        Die Website wird bei einem Dienstleister gehostet. Beim Besuch werden technisch notwendige Server-Logdaten
        (z. B. IP-Adresse, Datum/Uhrzeit, abgerufene Seite) zur Sicherstellung des Betriebs verarbeitet
        (Art. 6 Abs. 1 lit. f DSGVO).
      </p>
    </div>
    <div>
      <p className="text-charcoal font-medium">7. Ihre Rechte</p>
      <p>
        Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung,
        Datenübertragbarkeit sowie Widerspruch. Zudem können Sie sich bei einer Datenschutz-Aufsichtsbehörde
        beschweren. Zuständig in Bayern: Bayerisches Landesamt für Datenschutzaufsicht (BayLDA).
      </p>
    </div>
  </div>
);

export const Legal = () => {
  const [type, setType] = useState(null);

  useEffect(() => {
    const handler = (e) => setType(e.detail);
    window.addEventListener("open-legal", handler);
    return () => window.removeEventListener("open-legal", handler);
  }, []);

  useEffect(() => {
    document.body.style.overflow = type ? "hidden" : "";
    const onKey = (e) => {
      if (e.key === "Escape") setType(null);
    };
    if (type) window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [type]);

  if (!type) return null;

  return (
    <div
      data-testid="legal-modal"
      role="dialog"
      aria-modal="true"
      aria-label={type === "impressum" ? "Impressum" : "Datenschutzerklärung"}
      className="fixed inset-0 z-[80] bg-charcoal/70 backdrop-blur-sm flex items-center justify-center p-4 sm:p-6"
      onClick={() => setType(null)}
    >
      <div
        className="relative w-full max-w-2xl max-h-[85vh] overflow-y-auto rounded-[1.75rem] bg-cream ring-1 ring-gold/25 p-7 sm:p-10"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          data-testid="legal-close"
          onClick={() => setType(null)}
          className="absolute top-5 right-5 text-charcoal-muted hover:text-charcoal"
          aria-label="Schließen"
        >
          <X size={24} />
        </button>
        <h2 className="font-serif text-3xl sm:text-4xl font-light text-charcoal mb-8">
          {type === "impressum" ? "Impressum" : "Datenschutzerklärung"}
        </h2>
        {type === "impressum" ? <Impressum /> : <Datenschutz />}
      </div>
    </div>
  );
};
